import { render, staticRenderFns } from "./PxTimeline.vue?vue&type=template&id=dffcd440"
import script from "./PxTimeline.vue?vue&type=script&lang=js"
export * from "./PxTimeline.vue?vue&type=script&lang=js"
import style0 from "./PxTimeline.vue?vue&type=style&index=0&id=dffcd440&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports